import { Text } from '@mentimeter/ragnar-ui/text';
import { useRef } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { TextFitGhost } from '../components/text-fit-ghost/TextFitGhost';
import { AXIS_LABEL_PADDING, AXIS_LABEL_SIZE, FONT_SIZES } from './constants';

export const HorizontalAxis = ({ text }: { text: string }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <Box
      ref={containerRef}
      width="100%"
      height={AXIS_LABEL_SIZE}
      mt={AXIS_LABEL_PADDING}
      style={{ opacity: 0 }}
    >
      <TextFitGhost
        text={text}
        fontSizes={FONT_SIZES}
        width="100%"
        height={AXIS_LABEL_SIZE}
        finalFontSizeContainerRef={containerRef}
      >
        {(ref) => (
          <Text ref={ref} style={{ alignSelf: 'center' }} aria-hidden="true">
            {text} →
          </Text>
        )}
      </TextFitGhost>
      <Text fontSize="inherit" style={{ alignSelf: 'center' }}>
        {text} →
      </Text>
    </Box>
  );
};
